(() => {
  const root = document.querySelector('[data-monolith-brands]');
  if (!root) return;
  const cards = [...root.querySelectorAll('.mnb__card')];
  const search = root.querySelector('[data-mnb-search]');
  const alphabet = root.querySelector('[data-mnb-alphabet]');
  const count = root.querySelector('[data-mnb-count]');
  const empty = root.querySelector('[data-mnb-empty]');
  const normalize = value => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  const letters = [...new Set(cards.map(card => normalize(card.dataset.mnbName).charAt(0).toUpperCase()))].sort();
  let activeLetter = '';
  const makeButton = (label, letter) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = label;
    button.dataset.letter = letter;
    button.setAttribute('aria-pressed', letter === '' ? 'true' : 'false');
    alphabet.append(button);
  };
  makeButton(root.dataset.allLabel || 'All', '');
  letters.forEach(letter => makeButton(letter, letter));
  const update = () => {
    const term = normalize(search.value);
    let visible = 0;
    cards.forEach(card => {
      const name = normalize(card.dataset.mnbName);
      const match = name.includes(term) && (!activeLetter || name.charAt(0).toUpperCase() === activeLetter);
      card.hidden = !match;
      if (match) visible++;
    });
    count.textContent = visible;
    empty.hidden = visible > 0;
    alphabet.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.letter === activeLetter)));
  };
  search.addEventListener('input', update);
  alphabet.addEventListener('click', event => {
    const button = event.target.closest('button[data-letter]');
    if (!button) return;
    activeLetter = button.dataset.letter;
    update();
  });
})();
